import React from 'react';
import PropTypes from 'prop-types';
import { Field, CardTitle } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';

import { ReferenceDataField } from '~/components/ReferenceData';

const RELIEF_TYPES = [
  'Small',
  'Moderate',
  'Large',
  'None',
].map(r => ({
  label: r,
  value: r,
}));

const RELIEF_DURATIONS = [
  'Short term',
  'Long term',
  'No relief',
].map(r => ({
  label: r,
  value: r,
}));

const YES_NO = [
  'Yes',
  'No',
].map(r => ({
  label: r,
  value: r,
}));

const Fields = ({ disabled }) => {
  const { values } = useFormikContext();

  return (
    <fieldset disabled={disabled}>
      <Row form>
        <Col sm={4}>
          <ReferenceDataField
            tableName="medication"
            name="medicationUid"
            label="Medication"
            disabled={disabled || values.id}
            required
          />
        </Col>

        <Col sm={4}>
          <Field
            name="dosage"
          />
        </Col>

        <Col sm={4}>
          <Field
            name="frequency"
          />
        </Col>

        <Col sm={6}>
          <Field
            name="startedDate"
            label="Start Date"
            type="date"
          />
        </Col>

        <Col sm={6}>
          <Field
            name="finishedDate"
            label="End Date"
            type="date"
          />
        </Col>

        <Col sm={4}>
          <Field
            name="isPrimary"
            label="Primary Rx"
            type="checkbox"
          />
        </Col>

        <Col sm={4}>
          <Field
            name="isPrescription"
            label="Prescribed?"
            type="checkbox"
          />
        </Col>

        <Col sm={4}>
          <Field
            name="isStillTaking"
            label="Still taking?"
            type="checkbox"
          />
        </Col>

        <Col sm={12}>
          <ReferenceDataField
            tableName="medication-route"
            name="medicationRoutes"
            label="Route(s) of administration"
            multi
          />
        </Col>

        <Col sm={12}>
          <Field
            name="comments"
            type="textarea"
            rows={4}
          />
        </Col>
      </Row>

      <CardTitle>Relief and Improvement</CardTitle>

      <Row form>
        <Col sm={12}>
          <Field
            name="patientReportedImprovement"
            label="Did symptoms improve?"
            type="radio-group"
            options={YES_NO}
            inline
          />
        </Col>

        <Col sm={6}>
          <Field
            name="reliefRating"
            type="radio-group"
            options={RELIEF_TYPES}
            columns={2}
          />
        </Col>

        <Col sm={6}>
          <Field
            name="reliefDuration"
            type="radio-group"
            options={RELIEF_DURATIONS}
            columns={2}
          />
        </Col>
      </Row>
    </fieldset>
  );
};

Fields.propTypes = {
  disabled: PropTypes.bool,
};

Fields.defaultProps = {
  disabled: false,
};

export default Fields;
